// The primary + secondary percentages on one screen add up past 100% — a
// course would cost more than it brings in. Only a hint: it never blocks a
// save, and it checks just the two fields beside it, not the other levels.
export function PercentSumWarning({
  primary,
  secondary,
}: {
  primary: number | null | undefined;
  secondary: number | null | undefined;
}) {
  if ((Number(primary) || 0) + (Number(secondary) || 0) <= 100) return null;
  return <div className="text-small text-warning-yellow mt-1">סך האחוזים עולה על 100% מהכנסות החוג</div>;
}
